// src/data/profileBanner.ts
import resumePdf from "../Mikhil-Resume.pdf";

export const profileBanner = {
  backgroundImage: { url: "/images/your-bg.jpg" },
  headline: "Hello, I'm Mikhil Anand",
  resumeLink: { url: resumePdf },
  linkedinLink: "https://www.linkedin.com/in/mikhil-anand-aa593437/",
  profileSummary:
    "Computer Science student at NUS passionate about bridging AI/ML research with production-ready software.",
};
